export default __webpack_public_path__ + "a15d598fbc9efc01a310f0c8372fbf57.svg";